import React, { useEffect, useState } from "react";
import axiosClient from "../../../../../api/axiosClient";
import MaterialSelector from "./MaterialSelector";

export default function BOQLineRow({
  row,
  index,
  onChange,
  onDelete,
  readOnly,
  onProcessChange, // ✅ NEW (safe optional)
}) {
  const [local, setLocal] = useState(row);
  const [saving, setSaving] = useState(false);

  // ------------------------------------------------------------
  // SAFE MERGE FROM PARENT
  // ------------------------------------------------------------
  useEffect(() => {
    setLocal((prev) => ({
      ...row,
      uom_code: row.uom_code ?? prev.uom_code,
      uom_id: row.uom_id ?? prev.uom_id,
    }));
  }, [row]);

  // ------------------------------------------------------------
  // SAVE TO BACKEND
  // ------------------------------------------------------------
  const save = async (payload) => {
    try {
      setSaving(true);

      const res = await axiosClient.put(
        `/api/ppe/orders/boq-master-lines/${row.id}`,
        payload
      );

      const updated = {
        ...local,
        ...payload,
        ...res.data.data,
      };

      setLocal(updated);
      onChange(updated);
    } catch (err) {
      alert(
        err?.response?.data?.message ||
          "Failed to update BOQ line"
      );
    } finally {
      setSaving(false);
    }
  };

  // ------------------------------------------------------------
  // FIELD UPDATE
  // ------------------------------------------------------------
  const update = (field, value) => {
    const updated = {
      ...local,
      [field]: value,
    };

    setLocal(updated);

    if (!readOnly) {
      save({ [field]: value });
    }
  };

  // ------------------------------------------------------------
  // MATERIAL TYPE CHANGE
  // ------------------------------------------------------------
  const changeMaterialType = (type) => {
    const reset = {
      material_type: type,
      raw_material_id: null,
      bought_out_item_id: null,
      sub_part_variant_id: null,
    };

    const updated = {
      ...local,
      ...reset,
    };

    setLocal(updated);
    save(reset);
  };

  // ------------------------------------------------------------
  // ✅ PROCESS CHANGE HANDLER
  // ------------------------------------------------------------
  const handleProcessChange = (field, value) => {
    update(field, value);

    // notify parent for child row logic
    if (onProcessChange) {
      onProcessChange(local, field, value);
    }
  };

  // ------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------
  return (
    <tr
      style={{
        background: local.is_auto_generated ? "#f9fafb" : "white",
      }}
    >
      <td style={{ paddingLeft: local.parent_line_id ? 30 : 8 }}>
        {local.sequence_no || index + 1}
      </td>

      <td>
        <select
          className="form-select form-select-sm"
          value={local.material_type || "RAW"}
          
          //disabled={readOnly}
          disabled={true}
          onChange={(e) =>
            changeMaterialType(e.target.value)
          }
        >
          <option value="RAW">RAW</option>
          <option value="BOUGHT_OUT">BOUGHT OUT</option>
          <option value="SUB_PART">SUB PART</option>
        </select>
      </td>

      <td>
        <MaterialSelector
          materialType={local.material_type}
          value={local}
          disabled={readOnly}
          onSelect={(payload) => {
            const updated = {
              ...local,
              ...payload,
            };
            setLocal(updated);
            save(payload);
          }}
        />
      </td>

      <td>
        <input
          className="form-control form-control-sm"
          value={local.uom_code || ""}
          disabled
          readOnly
        />
      </td>

      <td>
        <input
          type="number"
          className="form-control form-control-sm"
          value={local.quantity_per_unit || ""}
          disabled={readOnly}
          onChange={(e) =>
            update(
              "quantity_per_unit",
              e.target.value
            )
          }
        />
      </td>

      <td>
        <input
          type="number"
          className="form-control form-control-sm"
          value={local.scrap_percent || ""}
          disabled={readOnly}
          onChange={(e) =>
            update(
              "scrap_percent",
              e.target.value
            )
          }
        />
      </td>

      {/* ============================================================
         ✅ NEW: PROCESS FLAGS UI
         ============================================================ */}

      <td>
        <select
          className="form-select form-select-sm"
          value={local.painting_required ? "YES" : "NO"}
          disabled={readOnly || local.is_auto_generated}
          onChange={(e) =>
            handleProcessChange(
              "painting_required",
              e.target.value === "YES"
            )
          }
        >
          <option value="NO">No</option>
          <option value="YES">Yes</option>
        </select>
      </td>

      <td>
        <select
          className="form-select form-select-sm"
          value={local.insulation_required ? "YES" : "NO"}
          disabled={readOnly || local.is_auto_generated}
          onChange={(e) =>
            handleProcessChange(
              "insulation_required",
              e.target.value === "YES"
            )
          }
        >
          <option value="NO">No</option>
          <option value="YES">Yes</option>
        </select>
      </td>

      <td>
        <select
          className="form-select form-select-sm"
          value={local.fabrication_required ? "YES" : "NO"}
          disabled={readOnly || local.is_auto_generated}
          onChange={(e) =>
            handleProcessChange(
              "fabrication_required",
              e.target.value === "YES"
            )
          }
        >
          <option value="NO">No</option>
          <option value="YES">Yes</option>
        </select>
      </td>

      <td>
        <input
          className="form-control form-control-sm"
          value={local.remarks || ""}
          disabled={readOnly}
          onChange={(e) =>
            update("remarks", e.target.value)
          }
        />
      </td>

      <td>
        {!readOnly && (
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={onDelete}
            disabled={saving}
          >
            ×
          </button>
        )}
      </td>
    </tr>
  );
}